module.exports = __webpack_public_path__ + "1792395595471/images/mastercard2.478335a.png";